/**
 * Checks whether the set of available permissions contain the specified required permissions.
 * @param availablePermissions The set of available permissions.
 * @param requiredPermissions The required permissions.
 * @returns True if the available permissions contains the required permissions.
 */
export function checkPermission(availablePermissions: ReadonlyArray<string>, requiredPermissions: string | (ReadonlyArray<string | ReadonlyArray<string>>)): boolean {
  const shellPermissionsSet = new Set(availablePermissions);

  if (typeof requiredPermissions === "string")
    return shellPermissionsSet.has(requiredPermissions);

  for (const permission of requiredPermissions) {
    if (!permission)
      continue;

    if (permission.length === 0)
      continue;

    if (typeof permission === "string") {
      if (!shellPermissionsSet.has(permission)) return false;
      continue;
    }

    if (!permission.some((optionalPermission) => shellPermissionsSet.has(optionalPermission))) return false;
  }

  return true;
}
